import moment from "moment";

function getNowDate(): string {
    return moment().format('YYYY-MM-DD')
}

export default getNowDate